import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow } from '../General/Table';
import { getRequestDetailItemInfo } from '../../../utilities/selectors';
import { getZemplinRequestDetailItemInfo } from '../selectors';
import { formatPriceToString } from '../../../utilities';

export interface Props {
  item: any;
  theme: any;
  showMoreInfo: boolean;
}

function RequestDetailItemRow({ item, showMoreInfo }: Props) {
  const {
    ordernr,
    name,
    note,
    image,
    currency,
    totalPriceWithoutVat,
    unitprice,
  } = getRequestDetailItemInfo(item);
  const { count, unit } = getZemplinRequestDetailItemInfo(item);

  return (
    <StyledTableRow>
      <ImageNameTableTd>
        <Image alt={`Obrázok ku produktu ${name}`} src={image} />
        <NameInputWrapper>
          <Name>{name}</Name>
          <OrderNr>{ordernr}</OrderNr>
        </NameInputWrapper>
      </ImageNameTableTd>
      {showMoreInfo && (
        <StyledTableTd>
          <CellText>{formatPriceToString(unitprice, currency)}</CellText>
        </StyledTableTd>
      )}
      <StyledTableTd>
        <CellText>{`${count} ${unit}`}</CellText>
      </StyledTableTd>
      <StyledTableTd>
        <Note>{note}</Note>
      </StyledTableTd>
      {showMoreInfo && (
        <StyledTableTd>
          <CellText>
            {formatPriceToString(totalPriceWithoutVat, currency)}
          </CellText>
        </StyledTableTd>
      )}
    </StyledTableRow>
  );
}

const StyledTableTd = styled(TableTd)`
  padding: ${rem(16)} 0;
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};

  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const CellText = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 300;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Note = styled(CellText)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ImageNameTableTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
`;

const Image = styled.img`
  width: ${rem(48)};
  height: ${rem(48)};
  max-width: initial;
  margin-right: ${rem(16)};
`;

const NameInputWrapper = styled(FlexCol)`
  max-width: ${rem(500)};

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(220)};
  `}

  ${({ theme }) => theme.mediab.l1050`
      max-width: ${rem(130)};
  `}

  ${({ theme }) => theme.mediab.l925`
      max-width: ${rem(200)};
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-bottom: ${rem(4)};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-family: ${({ theme }) => theme.font.secondaryLight};
  font-weight: 300;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: ${rem(400)}; */
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  /* ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(300)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
  `} */
`;

export const OrderNr = styled(TextP)`
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  color: ${({ theme }) => theme.colors.placeholder};
  text-align: left;
  font-family: ${({ theme }) => theme.font.tertiary};
  font-weight: 300;
`;

const WithThemeRow: any = withTheme(RequestDetailItemRow);
export { WithThemeRow as RequestDetailItemRow };
